export default "/fonts/vendor/katex/dist/KaTeX_Fraktur-Bold.woff?354501bac435c3264834b80301089bad";